import { Avatar, Card, Group, Stack, Text } from '@mantine/core'
import { IconExternalLink } from '@tabler/icons-react'
import { IntelligencePageHeader } from './shared'
import purviewIcon from '../../assets/purview_icon.svg'
import privaceraIcon from '../../assets/privacera_icon.png'
import sharepointIcon from '../../assets/sharepoint_icon.svg'

interface GovernanceToolCardProps {
  title: string
  description: string
  href: string
  logoSrc: string
}

function GovernanceToolCard({
  title,
  description,
  href,
  logoSrc,
}: GovernanceToolCardProps) {
  return (
    <Card
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      withBorder
      style={{ cursor: 'pointer', textDecoration: 'none' }}
    >
      <Group align="flex-start" wrap="nowrap">
        <Avatar src={logoSrc} alt={`${title} logo`} size="md" radius="sm" />
        <Stack gap={4} style={{ flex: 1 }}>
          <Group gap="xs">
            <Text fw={700}>{title}</Text>
            <IconExternalLink size={14} color="var(--mantine-color-gray-6)" />
          </Group>
          <Text size="sm" c="dimmed">
            {description}
          </Text>
        </Stack>
      </Group>
    </Card>
  )
}

const PURVIEW_URL =
  import.meta.env.VITE_PURVIEW_URL ?? 'https://purview.microsoft.com/home'

const PRIVACERA_URL =
  import.meta.env.VITE_PRIVACERA_URL ??
  'https://privaceracloud.com/public/index.html'

const SHAREPOINT_URL =
  import.meta.env.VITE_GOVERNANCE_SHAREPOINT_URL ??
  'https://ldcorp.sharepoint.com/sites/DataGovernanceHub'

export function Governance() {
  return (
    <Stack>
      <IntelligencePageHeader
        title="Data Governance"
        description="Manage data governance, access policies, and privacy from the tools your organization already uses."
      />
      <Stack>
        <GovernanceToolCard
          title="Microsoft Purview"
          description="Browse the data catalog, classification labels, and compliance policies."
          href={PURVIEW_URL}
          logoSrc={purviewIcon}
        />
        <GovernanceToolCard
          title="Privacera"
          description="Review and manage data access, privacy, and security policies."
          href={PRIVACERA_URL}
          logoSrc={privaceraIcon}
        />
        <GovernanceToolCard
          title="Data Governance SharePoint"
          description="Browse governance documents, exams, MRAs, and data strategy evidence."
          href={SHAREPOINT_URL}
          logoSrc={sharepointIcon}
        />
      </Stack>
    </Stack>
  )
}
